import Caption from '@/shared/components/typography/Caption'
import Text from '@/shared/components/typography/Text'
import Tint from '@/shared/components/typography/Tint'
import Title from '@/shared/components/typography/Title'

export { Text, Tint, Caption, Title }
